import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UserCheck } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Sticky banner shown whenever a parent is acting as one of their children.
 * Always visible so the parent knows which identity every click/post is being
 * attributed to and can bail back to their own account with one click.
 */
const ImpersonationBanner: React.FC = () => {
  const { impersonatedBy, user, stopImpersonating } = useAuth();
  const navigate = useNavigate();

  if (!impersonatedBy || !user) return null;

  const handleStop = () => {
    stopImpersonating();
    navigate('/parent');
  };

  return (
    <div className="sticky top-0 z-[60] bg-amber-500 text-slate-900 shadow">
      <div className="max-w-6xl mx-auto px-4 py-2 flex items-center justify-between gap-3 text-sm">
        <div className="flex items-center gap-2 min-w-0">
          <UserCheck className="w-4 h-4 flex-shrink-0" />
          <span className="truncate">
            <strong>Acting as {user.firstName} {user.lastName}</strong>
            <span className="opacity-80"> · signed in as {impersonatedBy.name}</span>
          </span>
        </div>
        <button
          onClick={handleStop}
          className="whitespace-nowrap bg-slate-900 text-white px-3 py-1 rounded-full text-xs font-semibold hover:bg-slate-800 transition-colors"
        >
          Switch back
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
